import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { environment } from 'src/environments/environment.prod';
import jwt_decode from 'jwt-decode';
import { KeycloakService } from 'keycloak-angular';
import { EnvironmentLoaderService } from './environment-loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarComponent } from 'src/app/shared/components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private http = inject(HttpClient);
  private keycloakService = inject(KeycloakService);
  private envLoaderSerive = inject(EnvironmentLoaderService);
  private snackBar = inject(MatSnackBar);

  path = 'api/v1/keycloak/PartnerHub';
  entityId = localStorage.getItem('companyHiringTypeId');
  selectedRole = localStorage.getItem('selectedRole');
  appName = localStorage.getItem('appName');

  baseUrlPartnerHubServices = '';
  baseUrlPartnerHubFrameWorkServices = '';
  timesheetBaseUrl = '';

  private _roleDetails = new BehaviorSubject({});
  _currentDetails = this._roleDetails.asObservable();

  private refreshSubject = new BehaviorSubject<void>(null);
  refresh$ = this.refreshSubject.asObservable();

  private accessSubject = new BehaviorSubject<boolean>(null);
  access$ = this.accessSubject.asObservable();
  private loaderSubject = new BehaviorSubject<boolean>(null);
  loader$ = this.loaderSubject.asObservable();

  constructor() {
    this.envLoaderSerive.getEnvData().then((envjson) => {
      environment.partnerHubUrlInTap = envjson['InTapPartnerHubUrl'];
      environment.partnerHubServices = envjson['PartnerHubServices'];
      environment.ecmsPartnerHubGateWayUrl = envjson['ECMSPartnerHubGateWayUrl'];
      environment.KeyClockServiceUrl = envjson['KeyClockServiceUrl'] || envjson['keyClockServiceUrl'];
      environment.timeSheetServiceUrl = envjson['TimeSheetServiceUrl'];
      environment.partnerHubFrameWorkServices = envjson['PartnerHubFrameWorkServices'];
      this.timesheetBaseUrl = environment.timeSheetServiceUrl;
      this.baseUrlPartnerHubFrameWorkServices = environment.partnerHubFrameWorkServices;
    });
  }

  changedRoleDetails(roleDetails) {
    this._roleDetails.next(roleDetails);
  }

  triggerRefresh() {
    this.refreshSubject.next();
  }

  accessCheck(accessValue) {
    this.accessSubject.next(accessValue);
  }

  loaderStart(flag) {
    this.loaderSubject.next(flag);
  }

  getUserDetails() {
    this.baseUrlPartnerHubServices = environment.partnerHubServices;
    return this.http.get<any>(this.baseUrlPartnerHubServices + 'api/userDetails');

    // return this.http.get<any>("/assets/json/userDetails.json");
  }

  //change or update password //keycloak
  resetPassword(resetObj) {
    const accessToken = localStorage.getItem('access_token');
    const jwttoken1 = jwt_decode(accessToken) as any;
    const kcUserId = jwttoken1.sub;
    const baseurl = environment.KeyClockServiceUrl;
    return this.http.post<any>(baseurl + kcUserId + '/password/isfupdate', resetObj);
  }

  //keycloak
  logoutSession() {
    const idToken = this.keycloakService.getKeycloakInstance().idToken;
    const baseurl = environment.keyClock;
    window.location.replace(
      baseurl +
        '/realms/' +
        'PartnerHub' +
        '/protocol/openid-connect/logout?post_logout_redirect_uri=' +
        window.location.origin +
        '&id_token_hint=' +
        idToken,
    );
  }

  getDisclaimerConsent(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      }),
    };
    this.appName = localStorage.getItem('appName');
    return this.http.get<any>(
      this.baseUrlPartnerHubServices + 'fetchdpoconsent?appName=' + this.appName + '&entityId=' + this.entityId,
      httpOptions,
    );
  }

  SaveConsent(url, consentObj) {
    // return this.http.get<any>("assets/json/saveConsent.json")
    if (url) {
      return this.http.post<any>(url, consentObj);
    }
    return this.http.post<any>(this.baseUrlPartnerHubServices + 'saveconsent', consentObj);
  }

  dpoCheck(reqId, appName) {
    this.entityId = localStorage.getItem('companyHiringTypeId');
    return this.http.get<any>(
      this.baseUrlPartnerHubServices + 'dpoCheck?reqId=' + reqId + '&appName=' + appName + '&entityId=' + this.entityId,
    );
  }

  getJobApply(appName) {
    // return this.http.get<any>("/assets/json/jobApplyData.json")
    this.entityId = localStorage.getItem('companyHiringTypeId');
    return this.http.get<any>(
      this.baseUrlPartnerHubServices + 'getJobApplyJson?entityId=' + this.entityId + '&appName=' + appName,
    );
  }

  //keycloak
  forgotPassword(data): Observable<any> {
    const baseurl = environment.KeyClockServiceUrl;
    const requestBody = {
      email: data.emailX,
    };
    // return this.http.post<any>(baseurl + data.emailX + "/password/resetRL", '')
    return this.http.post<any>(baseurl + 'password/resetRL', requestBody);
  }

  openSnackBar(message: any, panelClass: string) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration: 2500,
    });
  }
  openSnackBarNew(message: any, panelClass: string, duration: any) {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: message,
      panelClass: panelClass,
      duration: duration,
    });
  }

  restrictSpclChar(e) {
    const key = document.all ? e.keyCode : e.which;
    return (
      (key > 64 && key < 91) ||
      (key > 96 && key < 123) ||
      key == 8 ||
      key == 32 ||
      (key >= 48 && key <= 57) ||
      key == 45 ||
      key == 46 ||
      key == 44
    );
  }

  rstrctPasteSpclChar(e) {
    if (e && e.clipboardData && e.clipboardData.getData('text')) {
      if (!e.clipboardData.getData('text').match('^[a-zA-Z0-9 .,-]*$')) {
        return false;
      }
    }
  }

  dpoCheckForSubcon(roleSelected) {
    this.entityId = localStorage.getItem('companyHiringTypeId');
    return this.http.get<any>(
      this.baseUrlPartnerHubServices + 'subConDpoCheck?roleName=' + roleSelected + '&entityId=' + this.entityId,
    );
  }

  getTimesheetAuth() {
    return this.http.get<any>(this.timesheetBaseUrl + 'v1/timetrnemptimesheets/TimesheetLoginAuthorization');
  }

  blobURL(fileName) {
    let headers = new HttpHeaders();
    headers = headers.set('Cache-Control', 'no-cache');
    this.baseUrlPartnerHubFrameWorkServices = environment.partnerHubFrameWorkServices;
    return this.http.get<any>(
      this.baseUrlPartnerHubFrameWorkServices + 'azureblob/downloadFile?strQueryValue=' + fileName,
      { headers: headers },
    );
  }
}
